import { render } from "./bulletinList.vue?vue&type=template&id=02818e34&scoped=true"
import script from "./bulletinList.vue?vue&type=script&lang=js"
export * from "./bulletinList.vue?vue&type=script&lang=js"

import "./bulletinList.vue?vue&type=style&index=0&id=02818e34&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02818e34"],['__file',"resources/js/pages/bulletin/bulletinList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02818e34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02818e34', __exports__)) {
    console.log('reload')
    api.reload('02818e34', __exports__)
  }
  
  module.hot.accept("./bulletinList.vue?vue&type=template&id=02818e34&scoped=true", () => {
    console.log('re-render')
    api.rerender('02818e34', render)
  })

}


export default __exports__